import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get () {
    return ApiService.get('auditor/dashboard/statistics')
  }
}

export default DashboardService
